import { Configuration, OrganizationsApi } from '@/api';
import ApiConfig from '@/api/ApiConfig';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const useGetOrganizationQuery = (organizationId?: string, apiConfig?: Partial<ApiConfig>) => {
  const queryClient = useQueryClient();
  const organizationsApi = new OrganizationsApi(new Configuration(apiConfig || useAuth));

  const queryKey = ['organization', organizationId];

  const {
    data: organization,
    isLoading,
    error,
  } = useQuery({
    queryKey,
    queryFn: () => {
      if (!organizationId) throw new Error('Missing organizationId');
      return organizationsApi.getOrganization(organizationId);
    },
    enabled: !!organizationId,
  });

  const invalidateQuery = () => queryClient.invalidateQueries({ queryKey });

  return {
    organization,
    isLoading,
    error,
    invalidateQuery,
  };
};

export default useGetOrganizationQuery;
